export const sortModes = {
    title: "Title",
    code: "Code",
    modified: "Modified Date",
    lastModifiedBy: "Last User",
    owner: "Owner",
    title_descending: "Title (Desc)",
    code_descending: "Code (Desc)",
    modified_descending: "Modified Date (Desc)",
}
